var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.56 38.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.78,18H34.46V35s-.32,1.52-1.52,1.52h-2.3V42A2.31,2.31,0,0,1,26,42V36.71H22.24v5.47a2.09,2.09,0,0,1-2.37,2A2.19,2.19,0,0,1,17.66,42v-5.4H15.42A1.54,1.54,0,0,1,13.78,35Z",
    transform: "translate(-7.77 -6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.83,20.26A2.2,2.2,0,0,1,38.08,18a2.08,2.08,0,0,1,2.25,2.26v9.77a1.89,1.89,0,0,1-2.1,2.11c-2.33,0-2.4-1.54-2.4-2.2Z",
    transform: "translate(-7.77 -6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77,20.26A2.2,2.2,0,0,1,10,18a2.08,2.08,0,0,1,2.26,2.26v9.77a1.9,1.9,0,0,1-2.11,2.11c-2.33,0-2.4-1.54-2.4-2.2Z",
    transform: "translate(-7.77 -6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.12,9.25,30.91,6.6c.3-.43-.07-.53-.07-.53-.26-.2-.46.15-.46.15L28.53,9a11.55,11.55,0,0,0-4.29-.84A11.39,11.39,0,0,0,19.8,9c-.56-.81-2-2.88-2.1-2.94s-.3.08-.3.08c-.33.25-.18.38-.18.38l1.89,2.78a9.32,9.32,0,0,0-5.36,7.18h20.7A9.22,9.22,0,0,0,29.12,9.25Zm-9.41,4.41a1.15,1.15,0,0,1,0-2.3,1.15,1.15,0,0,1,0,2.3Zm8.86,0a1.15,1.15,0,1,1,1.16-1.15A1.16,1.16,0,0,1,28.57,13.66Z",
    transform: "translate(-7.77 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAndroid);
export default __webpack_public_path__ + "static/media/ic_android.52eefc9e5e9549245d322c7ff26b148d.svg";
export { ForwardRef as ReactComponent };